import { render, staticRenderFns } from "./UnreadNotes.vue?vue&type=template&id=d436c87a&scoped=true"
import script from "./UnreadNotes.vue?vue&type=script&lang=js"
export * from "./UnreadNotes.vue?vue&type=script&lang=js"
import style0 from "./UnreadNotes.vue?vue&type=style&index=0&id=d436c87a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d436c87a",
  null
  
)

export default component.exports